import { setState } from 'Utils/Store';

export const appConfigInitialState = {
  routes: null,
  strings: null,
  screens: null,
  defaultConfig: null,
};

export const setAppConfig = (appConfig) => setState('appConfig', appConfig);
